import crud, { ApiResponse } from "../crud";

export interface ChangeLogRecord {
  id: number;
  title: string;
  description: string;
  version: string;
  type: string;
  created_at: string;
}

export function ChangeLogsAPI(baseUrl: string) {
  return {
    get: async () => {
      return (await crud.get(
        `${baseUrl}/changelog`,
        undefined,
        true,
      )) as ApiResponse<ChangeLogRecord[]>;
    },
    getUnread: async () => {
      return (await crud.get(
        `${baseUrl}/changelog/unread`,
        undefined,
        true,
      )) as ApiResponse<ChangeLogRecord[]>;
    },
    markAsRead: async (id: number) => {
      return (await crud.post(
        `${baseUrl}/changelog/mark-read/${id}`,
        undefined,
        true,
      )) as ApiResponse<ChangeLogRecord>;
    },
  };
}
